import {
  WAREHOUSE_ALL,
  WAREHOUSE_GET,
  WAREHOUSE_DEL,
  WAREHOUSE_PUT,
  WAREHOUSE_POST,
  WAREHOUSE_LOADING,
  WAREHOUSE_ERROR,
} from '../../actions/types';

const initialState = {
  warehouse: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WAREHOUSE_LOADING:
      return { isLoading: true, isCompleted: true };
    case WAREHOUSE_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case WAREHOUSE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WAREHOUSE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WAREHOUSE_POST:
      return { isLoading: false, isCompleted: true };
    case WAREHOUSE_PUT:
      return { isLoading: false, isCompleted: true };
    case WAREHOUSE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
